angular
  .module('ATMGurus')
  .component('atmgFoot', {
    bindings: {
    },
    template: require('Templates/main/footer.html'),
    bindToController: {
    },
    scope: true,
    controllerAs: 'MainCtrl',
    controller: makeControllerFn()
  })

  function makeControllerFn() {
    return class AtmgFoot {

      constructor($scope, Navigation) {
        this.Navigation = Navigation
        this.year = new Date().getFullYear();
      }
    }
  }


// WEBPACK FOOTER //
// ./src/app/components/atmgFoot.js